// Feelgood PDP: Der grosse Produktpreis zeigt die GESAMTSUMME
// (Einzelpreis x ausgewaehlte Stueck), daneben bleibt "(€ 0,95 / Stk)".
//
// Kundenwunsch 2026-10-21: der grosse Preisblock zeigt die Summe, der
// "(Einzelpreis / ME)"-Vermerk daneben bleibt unveraendert.
//
// SCOPE: nur Shop-Seiten (.product-page-content = PDP-Marker,
// siehe shop_style_scope.js).
//
// EINZELPREIS-QUELLE: bevorzugt der small.formatted-price-Hinweis
// "(€ 0,95 / Stk)" - dieser wird nie angetastet. Der grosse Span wird
// ausschliesslich von uns beschrieben. Lektion aus der ersten Fassung:
// ohne verlaessliche Quell-Trennung interpretierte das Skript den eigenen
// Summen-Wert als neuen Einzelpreis -> Endlosschleife (Tab hing). Deshalb
// zusaetzlich lastWritten: eigene Schreibvorgaenge werden nie als Quelle
// uebernommen, auch nicht im Fallback-Pfad.
(function () {
	var SEL_PRICE = '.product-price span[itemprop="highPrice"]';
	var SEL_UOM = '.product-price small.formatted-price';
	var SEL_QTY = 'input.item-qty';

	function parseMoney(text) {
		var m = (text || "").replace(/\s/g, "").match(/-?[\d.,]+/);
		if (!m) return null;
		var s = m[0];
		if (s.indexOf(",") > -1) {
			s = s.replace(/\./g, "").replace(",", ".");
		}
		var v = parseFloat(s);
		return isNaN(v) ? null : v;
	}

	var lastUnitText = null;  // Fallback-Quelle (grosser Span)
	var lastWritten = null;   // letzter von uns geschriebener Text

	function update() {
		var content = document.querySelector(".product-page-content");
		if (!content) return;
		var priceEl = content.querySelector(SEL_PRICE);
		var qtyEl = content.querySelector(SEL_QTY);
		if (!priceEl || !qtyEl) return;

		var qty = parseInt(qtyEl.value, 10) || 0;

		// 1) Einzelpreis bevorzugt aus dem UOM-Hinweis "(€ 0,95 / Stk)"
		var unitText = null;
		var uomEl = content.querySelector(SEL_UOM);
		if (uomEl) {
			var um = (uomEl.textContent || "").match(/([^()]+)\s*\/\s*([^)]+)\)/);
			if (um && parseMoney(um[1]) !== null) {
				unitText = um[1].trim();
			}
		}

		// 2) Fallback: grosser Span, aber eigene Schreibvorgaenge ueberspringen
		if (unitText === null) {
			var text = priceEl.textContent.trim();
			if (text !== lastWritten) {
				lastUnitText = text;
			}
			unitText = lastUnitText;
		}

		var unit = parseMoney(unitText);
		if (unit === null) return;

		// Waehrungssymbol aus dem Einzelpreis-String uebernehmen ("€ ")
		var currency = (unitText.match(/^[^\d,.]+/) || [""])[0].trim();
		var totalStr = currency + (currency ? " " : "") +
			(unit * qty).toFixed(2).replace(".", ",");

		if (priceEl.textContent.trim() !== totalStr) {
			priceEl.textContent = totalStr;
			lastWritten = totalStr;
		}
	}

	function bind() {
		var content = document.querySelector(".product-page-content");
		if (!content) return;

		var qtyEl = content.querySelector(SEL_QTY);
		if (qtyEl) {
			qtyEl.addEventListener("input", update);
			qtyEl.addEventListener("change", update);
		}
		content.querySelectorAll(".item-qty-btn").forEach(function (btn) {
			btn.addEventListener("click", function () { setTimeout(update, 0); });
		});

		// UOM-/Preisblock-Mutationen (Variantenwechsel, Staffelpreis-JS) -> neu.
		var priceBlock = content.querySelector(".product-price");
		if (priceBlock && window.MutationObserver) {
			new MutationObserver(update).observe(priceBlock, { childList: true, characterData: true, subtree: true });
		}

		update();
	}

	function start() {
		bind();
		// Preise/Mengen werden teils nach dem ersten Render gefuellt
		// (Varianten-Vorbelegung) -> zweite Runde nach dem Layout.
		setTimeout(bind, 300);
		setTimeout(update, 600);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
})();
